export const UIThemes = {
	Primary: 'primary',
	Secondary: 'secondary',
	Blue: 'blue',
	Dark: 'dark',
	Red: 'red',
} as const;
